export default __webpack_public_path__ + "static/media/3108_call-sound.ru__.a20ff8ee.mp3";